import React, { createContext, useEffect, useState } from 'react'
import { ThemeProvider } from '@mui/material'
import './App.css'
import createTheme from './styles.js'
import RouteConfig from './routes'
import { matrixgoldContent, countersketchContent } from './Resources'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'
import { config } from './constants'
import { Amplify } from 'aws-amplify'
import { CookieStorage } from 'aws-amplify/utils'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { fetchUserAttributes } from 'aws-amplify/auth'
import Loading from './Loading'
import axios from 'axios'
import { getApiKey } from './Services'
import awsconfig from './awsconfig.js'

export const ConfigContext = createContext()
ReactGA.initialize(config.GOOGLE_ANALYTICS_4_TRAKING_ID)
const BASE_URL_STULLER = `${config.BASE_URL}/stuller`
Amplify.configure(awsconfig)
cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: config.DOMAIN,
    path: '/',
    secure: true
  })
)
const tagManagerArgs = {
  gtmId: config.GOOGLE_TAG_MANAGER
}
TagManager.initialize(tagManagerArgs)

const App = () => {
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState({})

  const location = useLocation()
  const words = location.pathname.substring(1).split('-')
  let product = words[0]
  if (product.indexOf('/') > -1) {
    product = product.substring(0, this.product.indexOf('/'))
  }
  if (!product) {
    product = 'matrixgold'
  }

  let productContent = undefined
  switch (product) {
    case 'countersketch':
      productContent = countersketchContent
      break
    default:
      productContent = matrixgoldContent
  }

  useEffect(() => {
    const getUsername = async () => {
      try {
        const userInfo = await fetchUserAttributes()
        return userInfo.preferred_username
      } catch (error) {
        return null
      }
    }
    const checkUser = async () => {
      try {
        const username = await getUsername()
        if (username) {
          await checkCurrentUserInfo(username)
        } else {
          const recaptchaApiKey = await getApiKey('gemvision-recaptchaV2-Key')
          setParams({ recaptchaApiKey })
        }
      } catch (error) {
        console.error(error)
      }
      setLoading(false)
    }
    checkUser()
  }, [])

  const checkCurrentUserInfo = async (username) => {
    const recaptchaApiKey = await getApiKey('gemvision-recaptchaV2-Key')
    const { data } = await axios.get(`${BASE_URL_STULLER}/userAccountInfo`, { params: { userId: username } })
    const {
      FirstName,
      LastName,
      Email,
      BillToAccount,
      BillToAccountObj: { PhoneNumber, State, Country, CompanyName }
    } = data
    setParams({
      first_name: FirstName,
      last_name: LastName,
      email: Email,
      phone: PhoneNumber,
      country: Country,
      org: CompanyName,
      state: State.slice(0, 2),
      stullerAccount: BillToAccount,
      checkAccount: BillToAccount ? true : false,
      recaptchaApiKey
    })
  }

  const resetContext = () => {
    setParams({})
  }

  return (
    <ConfigContext.Provider value={{ params, resetContext }}>
      <ThemeProvider theme={createTheme}>
        <Helmet>
          <title>{productContent.title}</title>
          <meta name='description' content={productContent.description1} />
          <meta property='title' content={productContent.title} />
        </Helmet>
        <div className='App'>
          <header>
            <a href='https://gemvision.com/'>
              <img src='https://gemvision.com/Images/gemvision_logo.svg' alt='logo' />
            </a>
          </header>
          {loading ? <Loading /> : <RouteConfig product={product} productContent={productContent} />}
          <footer>
            <p>Copyright © {new Date().getFullYear()} Gemvision. All rights reserved.</p>
          </footer>
        </div>
      </ThemeProvider>
    </ConfigContext.Provider>
  )
}

export default App
